import numeral from 'numeral';
import moment from 'moment';
import strings from './strings';

export function formatPrice(p) {
    return numeral(p).format('0,0');
}

export function formatDate(d) {
    return moment(d).format('L');
}

export function formatDateTime(d) {
    if (!moment.isMoment(d)) {
        d = moment(d);
    }
    return d.format('L hh:mm:ss A');
}

export function phoneLink(p) {
    let result = p.replace(/[^0-9]/g, '');

    // assume us
    if (result.charAt(0) !== '+') {
        result = '+1' + result;
    }

    return `tel:${result}`;
}

export function accountLabel(a) {
    return (
        (a.mentorId ? `${a.mentorId} - ` : '') +
        a.name +
        (!a.active ? ` (${strings.inactive})` : '')
    );
}

export function userLabel(u) {
    let label = '';

    if (u.firstName && u.lastName) {
        label = `${u.lastName}, ${u.firstName}`;
        if (u.email) {
            label += ` - ${u.email}`;
        }
    } else if (u.email) {
        label = u.email;
    } else {
        label = strings.newUser;
    }

    if (!u.active) {
        label += ` (${strings.inactive})`;
    }

    return label;
}

export function siteLabel(s) {
    return `${s.mentorId} - ${s.name}`;
}

export function serverLabel(s) {
    let label = s.mentorId;

    if (s.platform && s.platform.mentorId) {
        label += ` - ${s.platform.mentorId}`;
    }

    return label;
}

export function formatString(...args) {
    // The string containing the format items (e.g. "{0}")
    // will and always has to be the first argument.
    var theString = args[0];

    // start with the second argument (i = 1)
    for (var i = 1; i < args.length; i++) {
        // "gm" = RegEx options for Global search (more than one instance)
        // and for Multiline search
        var regEx = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
        theString = theString.replace(regEx, args[i]);
    }

    return theString;
}



// WEBPACK FOOTER //
// ./app/format.js